module.exports = __webpack_public_path__ + "static/media/undraw_male_avatar_323b.8ee210b2.png";